export default `query rmaOrdersAvailable{
  rmaOrdersAvailable{
    orderOptions {
      value
      label
    }
  }
}`
